<script>
  import getTranslation from '../../utilities/getTranslation';
  import {
    shouldShowOfferUsingDeprecatedBehaviour,
    hasActiveSubscription,
    isSubscriptionEmpty,
  } from './helper';
  import WrapperTitle from './SubscriptionCardComponents/WrapperTitle.svelte';
  import HighlightBanner from './SubscriptionCardComponents/HighlightBanner.svelte';
  import ProductTitle from './SubscriptionCardComponents/ProductTitle.svelte';
  import ProductDescription from './SubscriptionCardComponents/ProductDescription.svelte';
  import ProductPrice from './SubscriptionCardComponents/ProductPrice.svelte';
  import ProductUspList from './SubscriptionCardComponents/ProductUspList.svelte';
  import ProductOptions from './SubscriptionCardComponents/ProductOptions.svelte';
  import ProductOfferTerms from './SubscriptionCardComponents/ProductOfferTerms.svelte';

  export let subscription,
    componentInformationKeys,
    hasOfferSpan,
    hasOfferTerms,
    sthp,
    urlStyleLocale;

  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
  }

  const currentSubscription = subscription.currentSubscription;
  const upcomingSubscription = subscription.upcomingSubscription;
  const productMetadataIds = subscription.products.map((product) => product.metadataId);

  const currentUserSubscriptionId = subscription.products
    .filter(
      (product) =>
        product.metadataId === currentSubscription.metadataId ||
        product.aka.includes(currentSubscription.metadataId)
    )
    .map((product) => product.metadataId)[0];

  const productHasMultipleOptions = subscription.products.length > 1;
  const showCurrentPlanOnGroupLevel = !productHasMultipleOptions && currentUserSubscriptionId;
  const productsWithOffers = subscription.welcomeCampaigns.map((campaign) => campaign.productId);
  const isWelcomeCampaignEnabled = productsWithOffers.length > 0;

  const showWelcomeCampaign = subscription.products.some((product) =>
    productsWithOffers.find(
      (offerProductId) =>
        offerProductId === product.metadataId || product.aka.includes(offerProductId)
    )
  );

  const isMostPopular =
    productMetadataIds.find(
      (metadataId) => metadataId === subscription.featuredProductMetadataId
    ) && isSubscriptionEmpty(currentSubscription);

  const showOffer = isWelcomeCampaignEnabled
    ? showWelcomeCampaign
    : shouldShowOfferUsingDeprecatedBehaviour(
        [subscription],
        hasActiveSubscription([currentSubscription, upcomingSubscription]),
        subscription.isCustomerInactive
      );

  const offerInfo = {
    duration: getTranslation(subscription.informationKeys, 'pricing.offer.duration', ''),
    description: getTranslation(subscription.informationKeys, 'pricing.offer.description', ''),
  };

  const showUpcomingPlanOnGroupLevel = productMetadataIds.find(
    (metadataId) =>
      metadataId === upcomingSubscription.metadataId &&
      !currentSubscription.active &&
      !productHasMultipleOptions
  );

  const sharedProps = {
    isMostPopular,
    subscription,
  };

  const wrapperTitleProps = {
    isMostPopular,
    showCurrentPlanOnGroupLevel,
    showUpcomingPlanOnGroupLevel,
    currentSubscription,
    componentInformationKeys,
  };

  const highlightBannerProps = {
    ...sharedProps,
    showOffer,
    offerInfo,
    showCurrentPlanOnGroupLevel,
    showUpcomingPlanOnGroupLevel,
  };

  const productTitleProps = {
    ...sharedProps,
    showOffer,
    hasOfferTerms,
  };

  const productDescriptionProps = {
    ...sharedProps,
  };

  const productPriceProps = {
    ...sharedProps,
    hasOfferSpan,
    showOffer,
    offerInfo,
  };

  const productUspListProps = {
    ...sharedProps,
  };

  const productOptionsProps = {
    ...sharedProps,
    productMetaDataId: productMetadataIds[0],
    currentUserSubscriptionId,
    currentSubscription,
    upcomingSubscription,
    showOffer,
    componentInformationKeys,
    sthp,
    productsWithOffers,
    isWelcomeCampaignEnabled,
    urlStyleLocale,
  };

  let productId = productMetadataIds[0];

  const handleProductChange = (e) => {
    productId = e.detail;
  };
</script>

<WrapperTitle {...wrapperTitleProps} />

<HighlightBanner {...highlightBannerProps} />

<ProductTitle {...productTitleProps} />

<ProductDescription {...productDescriptionProps} />

<ProductPrice {...productPriceProps} />

<ProductUspList {...productUspListProps} />

<ProductOptions {...productOptionsProps} on:handleOfferTerms={handleProductChange} />

<ProductOfferTerms {...sharedProps} {showOffer} {productId} />
